import { Content } from '@backstage/core-components';
import { PageShareTitle } from '../../lib/shareTitle';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { getStoredFunMode, translate } from '../i18n';

const ANNOTATION = 'argocd/app-selector';

function parseTypeFromSelector(
  selector: string | undefined,
): string | undefined {
  if (!selector) return undefined;
  const match = selector.match(/type=([^,\s]+)/);
  return match ? match[1] : undefined;
}

/**
 * Resources editor tab on component entities of type services or ai-services.
 * Renders ResourceConfigTab inside the standard Content wrapper. Only shown
 * for components with an argocd/app-selector annotation whose type is
 * 'services' or 'ai-services'. Wiring is kept in sync by
 * packages/app/src/modules/configuration/resourceEntityContent.test.ts.
 */
export const resourceEntityContent = EntityContentBlueprint.make({
  name: 'resources',
  params: {
    path: '/resources',
    // Non-component config (evaluated once at extension registration), so
    // this reads the fun-mode flag directly instead of the useT() hook — see
    // the i18n module's non-component-code note.
    title: translate(
      'configuration.resourceEntityContent.title',
      getStoredFunMode(),
    ),
    group: 'configuration',
    filter: (entity: {
      kind: string;
      metadata: { annotations?: Record<string, string> };
    }) => {
      if (entity.kind !== 'Component') return false;
      const selector = entity.metadata.annotations?.[ANNOTATION];
      if (!selector) return false;
      const typeDir = parseTypeFromSelector(selector);
      return typeDir === 'services' || typeDir === 'ai-services';
    },
    loader: () =>
      import('./ResourceConfigTab').then(m => (
        <PageShareTitle title="Resource configuration">
          <Content>
            <m.ResourceConfigTab />
          </Content>
        </PageShareTitle>
      )),
  },
});
